// extracted by mini-css-extract-plugin
export default {"button":"Fo-z","reviewSort":"Go-z"};